export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h4 className="font-heading text-lg text-background-50 mb-3">酷漫屋</h4>
            <p className="text-xs md:text-sm text-background-300 leading-relaxed">
              提供流畅下拉式漫画阅读体验，支持竖屏滚动看漫画，海量条漫免费阅读。日漫韩漫国漫随心看，滑动翻页更舒适，是漫画爱好者的最佳阅读伴侣。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">快速导航</h4>
            <ul className="space-y-2">
              <li><a href="#hero" className="text-xs md:text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">首页</a></li>
              <li><a href="#ranking" className="text-xs md:text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">热门排行</a></li>
              <li><a href="#cards" className="text-xs md:text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">精选推荐</a></li>
              <li><a href="#features" className="text-xs md:text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">阅读特色</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">内容分类</h4>
            <ul className="space-y-2">
              <li><a href="#topics" className="text-xs md:text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">热门话题</a></li>
              <li><a href="#index" className="text-xs md:text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">主题索引</a></li>
              <li><a href="#updates" className="text-xs md:text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">更新动态</a></li>
              <li><a href="#app" className="text-xs md:text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">APP下载</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">合作伙伴</h4>
            <p className="text-xs md:text-sm text-background-400 leading-relaxed">
              感谢各位合作伙伴对酷漫屋的支持与信任。我们期待与更多优秀的漫画创作者、内容平台和品牌方建立深度合作，共同为漫画爱好者打造更好的阅读体验。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; 2024 酷漫屋 - 下拉式漫画免费全集在线阅读平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">关于我们</a>
            <a href="#contact" className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">联系我们</a>
            <a href="#faq" className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">常见问题</a>
          </div>
        </div>
      </div>
    </footer>
  );
}